import React from 'react';
import connectToStores from 'alt-store-connect';
import Flow from '../../components/flow';
import GraphStore from '../../stores/graph';

@connectToStores
class Navigation extends React.Component {

    static getStores(props) {
        return [GraphStore];
    }

    static getPropsFromStores(props) {
        return {
            graph: GraphStore.getState().graphs[props.flowId]
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        const inputs = [{ 'FlowId': this.props.flowId }, { 'EditingToken': this.props.graph.editingToken}];

        return <Flow tenantId={this.props.adminTenantId}
                     flowName="Navigation Edit"
                     component="modal-standalone"
                     callbacks={this.props.close}
                     inputs={inputs}
                     key="flow-navigation"
                     transition={0}>

        </Flow>
    }

}

export default Navigation;
